class Top {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    this.swiper = new Swiper('.pSwiper', {
      slidesPerView: 1.3,
      centeredSlides : true,
      navigation: {
        nextEl: ".s-service-ele02__btn-right",
        prevEl: ".s-service-ele02__btn-left"
      },
      breakpoints: {
        960: {
          centeredSlides : false,
          slidesPerView: 3,
        }
      },
    });

    this.swiper = new Swiper('.wSwiper', {
      slidesPerView: 1.3,
      spaceBetween: 0,
      centeredSlides : true,
      navigation: {
        nextEl: ".s-service-ele04__btn-right",
        prevEl: ".s-service-ele04__btn-left"
      },
      breakpoints: {
        960: {
          centeredSlides : false,
          slidesPerView: 3,
          spaceBetween: 0,
        }
      },
    });
  }
}
